import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "../../components/ui/Header2";
import RegistrationForm from "./components/RegistrationForm";
import SocialRegistration from "./components/SocialRegistration";
import EmailVerificationNotice from "./components/EmailVerificationNotice";
import Button from "../../components/ui/Button";
import Icon from "../../components/AppIcon";
import { useDispatch } from "react-redux";
import { getCountriesService } from "redux/services/general_service";

const Register = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const [registrationStep, setRegistrationStep] = useState("form"); // 'form', 'verification'
  const [userEmail, setUser] = useState("");

  const handleRegisterSuccess = (userData) => {
    setUser(userData.email);
    setRegistrationStep("verification");
  };

  const handleResendVerification = (email) => {
    console.log("Resending verification to:", email);
  };

  useEffect(() => {
    dispatch(getCountriesService())
  }, []);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />

      <main className="flex-grow flex items-center justify-center pt-16">
        {registrationStep === "form" ? (
          <div className="container mx-auto px-4 py-8 lg:py-12">
            <div className="max-w-lg mx-auto bg-white shadow-lg rounded-lg p-8">
              <h1 className="text-3xl font-bold text-center text-foreground mb-4">
                {t("createAccount")}
              </h1>
              <p className="text-lg text-muted-foreground text-center mb-6">
                {t("joinCustomers")}
              </p>

              {/* Already have account */}
              <div className="flex items-center justify-center space-x-2 text-sm mb-4">
                <span className="text-muted-foreground">
                  {t("alreadyHaveAccount")}
                </span>
                <Button
                  variant="link"
                  className="p-0 h-auto text-primary hover:underline"
                >
                  {t("signInHere")}
                </Button>
              </div>

              {/* Registration Form */}
              <div className="bg-card border border-border rounded-xl p-6 mb-4">
                <RegistrationForm onRegisterSuccess={handleRegisterSuccess} />
              </div>

              {/* Social Registration 
              <div className="bg-card border border-border rounded-xl p-6 mb-4">
                <SocialRegistration onSocialRegister={handleSocialRegister} />
              </div>*/}

  
            </div>
          </div>
        ) : (
          /* Email Verification Step */
          <div className="container mx-auto px-4 py-12">
            <div className="max-w-md mx-auto">
              <EmailVerificationNotice
                userEmail={userEmail}
                onResendVerification={handleResendVerification}
              />

              {/* Back to Form */}
              <div className="text-center mt-8">
                <Button
                  variant="ghost"
                  onClick={() => setRegistrationStep("form")}
                  iconName="ArrowLeft"
                  iconPosition="left"
                >
                  {t("backToRegistration")}
                </Button>
              </div>
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default Register;
